import { Route, Routes } from "react-router-dom";

import MainOrganizations from "../Organizations/MainOrganizations";
import OpenOrganization from "../Organizations/OpenOrganization";
import AIChatMain from "../AIChat/AiChatMain";
import MainMcps from "../MCPs/MainMcps";
import McpBuilder from "../MCPs/McpBuilder";
import MainMembers from "../Members/MainMembers";
import MainLLmDirectory from "../LLMDirectory/MainLLMDirectory";
import MainApiKeys from "../APIKeys/MainApiKeys";
import MainStorage from "../Storage/MainStorage";
import LogsMain from "../Logs/LogsMain";
import AiChatHistoryMain from "../AiChatHistory/AiChatHistoryMain";
import MainWorkflow from "../Workflows/MainWorkflow";
import CreateWorkflow from "../Workflows/CreateWorkflow";
import MainApps from "../Apps/MainApps";
import MainActions from "../Actions/MainActions";
import CreateAction from "../Actions/CreateAction";
import MainAnalytics from "../Analytics/MainAnalytics";
import MainBilling from "../Billing/MainBilling";
import MainFineTune from "../Finetune/MainFineTune";
import OpenFineTuneJob from "../Finetune/OpenFineTuneJob";
import MainOpenApp from "../MCPs/OpenApp/MainOpenApp";
import OpenAppWorkspace from "../Apps/OpenAppWorkspace";

const MainFrameContent = ({
    account_id,
    userData,
    fetchUserData,
    orgData,
    loadingOrgData,
    fetchOrgData,
    setMcpData,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    appData,
    fetchAppData,
    loadingAppData,
    setOpenSidebar,
    singleOrgData,
    fetchChatHistory,
    chatData,
    loadingChatData,

    loadingSingleOrg,
    fetchSingleOrganization
}) => {

    return (
        <div className="mainframe_content">
            <Routes>
                <Route
                    path="organizations"
                    element={
                        <MainOrganizations
                            account_id={account_id}
                            userData={userData}
                            loading={loadingOrgData}
                            data={orgData}
                            fetchData={fetchOrgData}
                        />
                    }
                />

                <Route
                    path="members"
                    element={
                        <MainMembers
                            account_id={account_id}
                            userData={userData}
                            orgData={orgData}
                            fetchOrgData={fetchOrgData}
                        />
                    }
                />

                <Route
                    path="storage/*"
                    element={
                        <MainStorage
                            account_id={account_id}
                            userData={userData}
                            orgData={orgData}
                            fetchOrgData={fetchOrgData}

                        />
                    }
                />

                <Route
                    path="api-keys"
                    element={
                        <MainApiKeys
                            account_id={account_id}
                        />
                    }
                />

                <Route
                    path="logs"
                    element={
                        <LogsMain
                            account_id={account_id}
                        />
                    }
                />

                <Route
                    path="analytics/:an_page"
                    element={
                        <MainAnalytics
                            account_id={account_id}
                            fetchOrgData={fetchOrgData}
                            orgData={orgData}
                            loadingOrgData={loadingOrgData}
                        />
                    }
                />

                <Route
                    path="billing/:bil_page"
                    element={
                        <MainBilling
                            account_id={account_id}
                            fetchUserData={fetchUserData}
                        />
                    }
                />

                <Route path="organizations/:org_id">
                    <Route
                        path="manage-org/:org_page"
                        element={
                            <OpenOrganization
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="playground/:chat_id"
                        element={
                            <AIChatMain
                                account_id={account_id}
                                userData={userData}
                                mcpData={mcpData}
                                fetchMcpData={fetchMcpData}
                                loadingMcpData={loadingMcpData}
                                setMcpData={setMcpData}
                            />
                        }
                    />

                    <Route
                        path="chat-history"
                        element={
                            <AiChatHistoryMain
                                account_id={account_id}
                                fetchChatHistory={fetchChatHistory}
                                chatData={chatData}
                                loadingChatData={loadingChatData}
                            />
                        }
                    />

                    <Route
                        path="apps"
                        element={
                            <MainApps
                                account_id={account_id}
                                appData={appData}
                                fetchAppData={fetchAppData}
                                loadingAppData={loadingAppData}
                                setOpenSidebar={setOpenSidebar}
                            />
                        }
                    />

                    <Route
                        path="apps/app-builder/:type/:app_id/:version"
                        element={
                            <OpenAppWorkspace
                                account_id={account_id}
                            />
                        }
                    />

                    <Route
                        path="llm-directory"
                        element={
                            <MainLLmDirectory
                                account_id={account_id}
                            />
                        }
                    />

                    <Route
                        path="abilities"
                        element={
                            <MainMcps
                                account_id={account_id}
                                userData={userData}
                                setMcpData={setMcpData}
                                mcpData={mcpData}
                                fetchMcpData={fetchMcpData}
                                loadingMcpData={loadingMcpData}
                            />
                        }
                    />

                    <Route
                        path="abilities/open-ability/:mcp_id/:version_n"
                        element={
                            <MainOpenApp
                                account_id={account_id}
                                userData={userData}
                                setMcpData={setMcpData}
                                mcpData={mcpData}
                                fetchMcpData={fetchMcpData}
                                loadingMcpData={loadingMcpData}
                            />
                        }
                    />

                    <Route
                        path="abilities/mcp-import"
                        element={
                            <>MCP Import</>
                        }
                    />

                    <Route
                        path="abilities/ability-builder/:runtime/:mcp_id/:version_n"
                        element={
                            <McpBuilder
                                userData={userData}
                                account_id={account_id}
                                singleOrgData={singleOrgData}
                            />
                        }
                    />

                    <Route
                        path="actions"
                        element={
                            <MainActions
                                account_id={account_id}
                                userData={userData}
                                orgData={orgData}
                                fetchOrgData={fetchOrgData}
                            />
                        }
                    />

                    <Route
                        path="actions/:act_id"
                        element={
                            <CreateAction
                                account_id={account_id}
                                userData={userData}
                                mcpData={mcpData}
                                fetchMcpData={fetchMcpData}
                                loadingMcpData={loadingMcpData}
                                singleOrgData={singleOrgData}
                            />
                        }
                    />

                    <Route
                        path="workflows"
                        element={
                            <MainWorkflow
                                account_id={account_id}
                                userData={userData}
                                orgData={orgData}
                                fetchOrgData={fetchOrgData}
                            />
                        }
                    />

                    <Route
                        path="workflows/:wf_id"
                        element={
                            <CreateWorkflow
                                account_id={account_id}
                                mcpData={mcpData}
                                fetchMcpData={fetchMcpData}
                                loadingMcpData={loadingMcpData}
                            />
                        }
                    />

                    <Route
                        path="fine-tuning"
                        element={
                            <MainFineTune
                                account_id={account_id}
                            />
                        }
                    />

                    <Route
                        path="fine-tune/:ft_id"
                        element={
                            <OpenFineTuneJob
                                account_id={account_id}
                            />
                        }
                    />


                </Route>

            </Routes>
        </div>
    );
};

export default MainFrameContent;